"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = ChevronLeftMedium;

var _ChevronLeftMedium = require("@adobe/react-spectrum-ui/dist/ChevronLeftMedium");

var _icon = require("@react-spectrum/icon");

var _react = _interopRequireDefault(require("react"));

function ChevronLeftMedium(props) {
  return /*#__PURE__*/_react.default.createElement(_icon.UIIcon, props, /*#__PURE__*/_react.default.createElement(_ChevronLeftMedium.ChevronLeftMedium, null));
}